import React, { useState } from 'react'
import { Panel } from 'rsuite'
import ApproverTable from './ApproverTable'

export default function ApproverListWidget({ schema }) {
  const [formSchema, setFormSchema] = useState(schema)

  return (
    <>
      <Panel
        className="grantee-profile-info"
        shaded
        header={formSchema.header}
        bordered
        collapsible
        defaultExpanded
        // style={{ marginBottom: 10 }}
      >
        {formSchema.projectApprover && <ApproverTable data={formSchema.projectApprover} />}

        {formSchema.contractChangeApprover && (
          <ApproverTable data={formSchema.contractChangeApprover} />
        )}

        {formSchema.closureApprover && <ApproverTable data={formSchema.closureApprover} />}
      </Panel>
    </>
  )
}
